<section class="tabs-wrapper">
    @for (option of options(); track $index) {
        <button
            (click)="value.set(option.value)"
            [class.active]="value() === option.value"
            class="tab"
        >
            @if (option.icon) {
                <app-icon
                    [name]="option.icon"
                    class="theme-text !size-3 md:!size-4"
                />
            }
            <p class="text-xs md:text-sm font-semibold theme-text">
                {{ option.label }}
            </p>
        </button>
    }
</section>
